/**
 * 테넌트 기능 스위치 — 특정 고객사 전용 기능을 코드가 아닌 **설정**으로 격리한다
 * (설계 `mes-mixing-orders-gupo-isolation.md` P0).
 *
 * 부팅 1회 `createMesFeApp(options)` 에서 확정되며 이후 불변이다. 라우트 등록 시점에도
 * 읽히므로 Pinia/provide 가 아니라 모듈 스코프에 둔다.
 */
export interface MesFeatureFlags {
  /**
   * 반죽지시(시간 지시형 작업지시) — 구포국수 전용.
   * 끄면 전용 화면·POP 모드 라우트가 등록되지 않고, 작업지시 화면의 반죽 탭·「반죽」 태그·
   * 작업시간/반죽지시 연결 UI 판정도 하지 않는다(= 다른 테넌트는 작업시간 값이 있어도 일반 지시).
   */
  mixingOrders: boolean;
}

const DEFAULT_FLAGS: MesFeatureFlags = { mixingOrders: false };

let flags: MesFeatureFlags = { ...DEFAULT_FLAGS };

/** `createMesFeApp` 전용 — 앱 부팅 시 1회. */
export function setMesFeatureFlags(next: Partial<MesFeatureFlags>): void {
  flags = { ...DEFAULT_FLAGS, ...next };
}

export function mesFeatures(): MesFeatureFlags {
  return flags;
}

/** 반죽지시 기능 사용 테넌트인가 (구포국수만 true). */
export function isMixingOrdersEnabled(): boolean {
  return flags.mixingOrders;
}

/** 테스트 전용 — 플래그 초기화. */
export function resetMesFeatureFlagsForTest(): void {
  flags = { ...DEFAULT_FLAGS };
}
